import { unit, breakpoints, IconButton, GridContainer, NavigationBar } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledGridContainer = styled(GridContainer) `
  display: flex;
  flex-direction: row;
  gap: ${unit('md')};

  ${breakpoints.sm} {
    gap: ${unit('xl')};
  }
`;
export const LeftSection = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${unit('xl')};
`;
export const StyledBarIconContainer = styled.div `
  display: block;
  ${breakpoints.md} {
    display: none;
  }
`;
export const SearchIconButton = styled(IconButton) `
  display: flex;
  ${breakpoints.md} {
    display: none;
  }
`;
export const StyledNavigationBar = styled(NavigationBar) `
  display: block;

  ${breakpoints.md} {
    display: none;
  }
`;
